module.exports = __webpack_public_path__ + "assets/hannah-working.jpg?v=0c7f5bec2add4711f3acbeddb7532617";